'use strict';

exports.schemaMixedSymbol = Symbol.for('mongoose:schema_mixed');

exports.builtInMiddleware = Symbol.for('mongoose:built-in-middleware');


//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/schema/symbols.js
// module id = 464
// module chunks = 0